import { DomainError } from './DomainError';

/**
 * Authentication error
 * Thrown when authentication fails (invalid credentials, expired tokens, etc.)
 */
export class AuthenticationError extends DomainError {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
  }

  static invalidCredentials(): AuthenticationError {
    return new AuthenticationError('Invalid email or password', 'INVALID_CREDENTIALS');
  }

  static tokenExpired(): AuthenticationError {
    return new AuthenticationError('Token has expired', 'TOKEN_EXPIRED');
  }

  static unauthorized(): AuthenticationError {
    return new AuthenticationError('Unauthorized access', 'UNAUTHORIZED');
  }

  static sessionExpired(): AuthenticationError {
    return new AuthenticationError('Session has expired', 'SESSION_EXPIRED');
  }
}
